export const encodeBase64 = (data) => {
  return window.btoa(data);
};

export const decodeBase64 = (data) => {
  return window.atob(data);
};
